import 'date-fns';
import { Component } from 'react';
import classnames from 'classnames';
import DateFnsUtils from '@date-io/date-fns';
import { FormControl, FormHelperText } from '@mui/material';
import { withStyles } from '@mui/styles';
import DatePicker from '@mui/lab/DatePicker';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import ErrorIcon from './assets/icon-error.svg';
import ValidIcon from './assets/icon-tick-outline.svg';
import APInputStyles from './styles/APInput.style';

class APInput extends Component<any, {}> {
  state = {
    touched: false
  };

  constructor(props: any) {
    super(props);

    this.onBlur = this.onBlur.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  onBlur(...args: any[]) {
    const {
      onBlur
    } = this.props;

    this.setState({
      touched: true
    });

    if (onBlur) {
      onBlur(...args);
    }
  }

  onChange(value: any) {
    const {
      name,
      onChange
    } = this.props;

    if (onChange) {
      onChange({
        target: {
          name,
          value
        }
      });
    }
  }

  render() {
    const {
      classes,
      className,
      error,
      helperText,
      onBlur,
      onChange,
      value,
      ...others
    } = this.props;

    const props = {
      ...others
    };

    const controlCls = classnames(classes.formControl, className);

    return (
      <LocalizationProvider utils={DateFnsUtils}>
        <FormControl className={controlCls}>
          <DatePicker
            error={error}
            variant="inline"
            inputVariant="outlined"
            format="dd/MM/yyyy"
            onBlur={this.onBlur}
            onChange={this.onChange}
            inputProps={{ "data-testid": "dateInput" }}
            value={value}
            {...props}
          />
          {helperText && (
            <FormHelperText className={classes.helperText} error={error}>
              {helperText}
            </FormHelperText>
          )}
          {error && (
            <img className={classes.stateIcon} src={ErrorIcon} alt="Invalid input icon" />
          )}
          {this.state.touched && !error && (
            <img className={classes.stateIcon} src={ValidIcon} alt="Valid input icon" />
          )}
        </FormControl>
      </LocalizationProvider>
    );
  }
}

export default withStyles(APInputStyles)(APInput);
